import { render, staticRenderFns } from "./ListCards.vue?vue&type=template&id=f1a8c52e&scoped=true"
import script from "./ListCards.vue?vue&type=script&lang=ts"
export * from "./ListCards.vue?vue&type=script&lang=ts"
import style0 from "./ListCards.vue?vue&type=style&index=0&id=f1a8c52e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a8c52e",
  null
  
)

export default component.exports